import { Button } from "@mui/material";
import { NavLink } from "react-router-dom";

type AddProps = {
  to: string;
  title?: string;
};

export function Add({ to, title = "ADD" }: AddProps) {
  return (
    <Button
      component={NavLink}
      to={`/${to}`}
      variant="contained"
      color="primary"
      sx={{ textTransform: "uppercase" }}
    >
      + {title}
    </Button>
  );
}
